class CubicMetres {

    constructor(length = null, width = null, height = null, amountInCubicMetres = null) {
        this.length = length;
        this.width = width;
        this.height = height;

        this.amountInCubicMetres = (amountInCubicMetres === null) ? this.calculate() : amountInCubicMetres;
    }

    calculate() {
        return parseFloat(Math.round(((this.length * this.width * this.height) * 1.05) * 10) / 10);
    }

    isValid() {
        return !isNaN(this.amountInCubicMetres) && this.amountInCubicMetres > 0;
    }

    static hasValue() {
        return $('[name="cubic_metres"]').val() !== '' && parseFloat($('[name="cubic_metres"]').val()) > 0;
    }

    static enableForm() {
        $('.order-form input:not(.calculate-cubic-metres input):not([name="_token"])').prop('disabled', false);
        $('.order-form .order-option:not(.cubic-metres):not([name="_token"])').stop().animate({opacity: 1}, 'fast');
    }

    static disableForm() {
        $('.order-form input:not(.calculate-cubic-metres input):not([name="_token"])').prop('disabled', true);
        $('.order-form .order-option:not(.cubic-metres):not([name="_token"])').stop().animate({opacity: 0.3}, 'fast');
    }

    static sanitizeField(jqueryElement) {
        return jqueryElement.val(jqueryElement.val().replace(/[a-zA-Z]/, '').replace(/,/, '.').replace(/-/, ''));
    }
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if(!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if(callNow) func.apply(context, args);
    };
};

function checkForAddress($zipcode, $houseNo, $targetAddress, $targetPlace) {
    if($zipcode.val() !== '' && $houseNo.val() !== '') {
        $('.zipcode-error').addClass('d-none');
        $zipcode.val($zipcode.val().replace(/ /, ''));

        if(!/[0-9]{4}[a-zA-Z]{2}/.test($zipcode.val())) {
            $('.zipcode-error').removeClass('d-none');
            return false;
        }

        $.ajax({
            type: 'POST',
            url:  '/adres-check',
            data: {
                '_token':   $('[name="_token"]').val(),
                'zipcode':  $zipcode.val(),
                'house_no': $houseNo.val()
            }
        }).always(function(response) {
            if(response.address !== null) {
                $targetAddress.val(response.address);
            } else {
                $targetAddress.attr('readonly', false);
            }

            if(response.place !== null) {
                $targetPlace.val(response.place);
            } else {
                $targetPlace.attr('readonly', false);
            }

            updateProgressBar();
            calculatePrice();
        });
    }
}

const calculatePrice = debounce(() => {
    let form = $('.order-form').serialize();

    if(CubicMetres.hasValue()) {

        axios.post('/', form).then((response) => {
            return response.data;
        }).then((response) => {
            // check for response.
            if(response.error !== null && typeof (response.error) !== 'undefined') {
                swal({
                    title:             'Fout!',
                    text:              response.error,
                    type:              'error',
                    confirmButtonText: 'Sluiten'
                });

                $('[name="delivery_zipcode"], [name="delivery_house_no"], [name="delivery_residence"], [name="delivery_address"]').val('');
            }

            if(response.price !== null && response.price !== undefined) {
                $('.refresh-price').text(response.price);

                if(response.unformattedPrice >= 50000) {
                    swal({
                        title:             'Limiet overschreden!',
                        text:              'Er mag voor maximaal €50.000,- aan beton besteld worden! Neem contact met ons op',
                        type:              'error',
                        confirmButtonText: 'Sluiten'
                    });

                    $('[name="cubic_metres"]').val(1);
                    calculatePrice();
                }

                if(response.options !== undefined && response.options !== null) {
                    var html = [];
                    for(var i in response.options) {
                        if(response.options[i] !== null) {
                            html.push([
                                '<span class="sub d-block">' + i + '</span>',
                                '<span class="bold d-block mb16">' + response.options[i] + '</span>'
                            ].join(''));
                        }
                    }

                    $('.option-container').html(html.join(''));

                    if(response.formattedAddress !== null) {
                        var html = [
                            '<div class="alert alert-info alert-dismissible" role="alert">',
                            '<button type="button" class="close" data-dismiss="alert" aria-label="Close">',
                            '<span aria-hidden="true">&times;</span>',
                            '</button>',
                            'De bezorgkosten voor: ' + response.formattedAddress + ' zijn verrekend met de prijs.',
                            '</div>'
                        ];
                        $('.delivery-costs').html(html.join(''));
                    }
                }
            }
        });
        /*$.ajax({
            type:       'POST',
            url:        '/',
            data:       form,
            beforeSend: function() {
                // Block the UI in the meantime.
            }
        }).always(function(response) {

        });*/
    }
}, 250);

function updateProgressBar() {
    var amount = 0;
    var filled = [];

    $('.order-option').each(function() {
        var found = false;
        var $option = $(this);

        $(this).find('input:not([name="length"], [name="width"], [name="height"])').each(function() {
            if(found === false) {
                if($(this).is(':radio')) {
                    found = true;
                    if($(this).is(':checked')) {
                        amount++;
                        filled.push($option);
                    }
                } else {
                    found = false;
                    if($(this).val() !== '') {
                        filled.push($option);
                    }
                    amount++;
                }
            }
        });
    });

    var percentage = (filled.length / amount) * 100;
    $('.progress-bar').css({width: percentage + '%'});
}

if(document.querySelector('.view-order')) {
    document.querySelector('.view-order').addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('.order-overview').scrollIntoView({
            behavior: 'smooth'
        });
    });

    const intersectionTarget = document.querySelector('.order-overview');

    const observer = new IntersectionObserver((entries, options) => {
        entries.forEach((entry) => {
            let visible = entry.intersectionRatio >= options.thresholds[0];

            if(visible) {
                document.querySelector('.sticky-order').style.opacity = 0;
            } else {
                document.querySelector('.sticky-order').style.opacity = 1;
            }
        });
    }, {
        root:      null,
        threshold: .1
    });

    observer.observe(intersectionTarget);
}


// Faq / accordion
var accordion = function() {

    var $accordion = $('.js-accordion');
    var $accordion_header = $accordion.find('.js-accordion-header');
    var $accordion_item = $('.js-accordion-item');

    // default settings
    var settings = {
        // animation speed
        speed: 400,

        // close all other accordion items if true
        oneOpen: true
    };

    return {
        // pass configurable object literal
        init:   function init($settings) {
            $accordion_header.on('click', function() {
                accordion.toggle($(this));
            });

            $.extend(settings, $settings);

            // ensure only one accordion is active if oneOpen is true
            if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
                $('.js-accordion-item.active:not(:first)').removeClass('active');
            }

            // reveal the active accordion bodies
            $('.js-accordion-item.active').find('> .js-accordion-body').show();
        },
        toggle: function toggle($this) {

            if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
                $this.closest('.js-accordion').find('> .js-accordion-item').removeClass('active').find('.js-accordion-body').slideUp();
            }

            // show/hide the clicked accordion item
            $this.closest('.js-accordion-item').toggleClass('active');
            $this.next().stop().slideToggle(settings.speed);
        }
    };
}();

$(document).ready(function() {
    accordion.init({
        speed:   300,
        oneOpen: true
    });

    if($('.alert.alert-danger:not(.d-none)').length > 0) {
        $('.tabs > li').eq($('.alert.alert-danger:not(.d-none)').eq(0).parents('li').index()).click();

        $('.alert.alert-danger:not(.d-none)').eq(0).get(0).scrollIntoView();
    }
});

// WOW animated
wow = new WOW({
    boxClass:     'wow', // default
    animateClass: 'animated', // default
    offset:       0, // default
    mobile:       true, // default
    live:         true // default
});
wow.init();

(function($) {
    "use strict"; // Start of use strict

    if($('.error.d-none').length > 0) {
        swal({
            title:             'Fout!',
            text:              $('.error.d-none').text(),
            type:              'error',
            confirmButtonText: 'Sluiten'
        });
    }

    if($('#hoseLength').length > 0) {
        $('#hoseLength').blur(function() {
            if(parseInt($(this).val()) > 80) {
                swal({
                    title:             'Fout!',
                    text:              'Maximaal 80 meter!',
                    type:              'error',
                    confirmButtonText: 'Sluiten'
                });

                $(this).val(80);
                calculatePrice();
            }
        });
    }

    $('[data-show-on]').hide();
    if($('[name="unloadType"]').val() === 'Pomp') {
        $('[data-show-on="Pomp"]').show();
    }
    if($('[name="unloadType"]').length > 0) {

        $('[name="unloadType"]').change(function(e) {
            if($(this).val() === 'Pomp') {
                $('[data-show-on="Pomp"]').slideDown();
            } else {
                $('[data-show-on="Pomp"]').slideUp();
            }
        });
    }

    //Datepicker
    let dayAfterTomorrow = new Date();
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 3);
    dayAfterTomorrow.setHours(0, 0, 0, 0);

    $('#DatePicker').datepicker({
        footer:            false,
        modal:             false,
        format:            'dd-mm-yyyy',
        minDate:           dayAfterTomorrow,
        showOnFocus:       true,
        weekStartDay:      1,
        disableDaysOfWeek: [0]
    });


    //Timepicker
    $('#TimePicker').timepicker({
        footer:      true,
        modal:       true,
        mode:        '24hr',
        showOnFocus: true,
    });

    var timepicker = $('#TimePicker').timepicker({
        format: 'HH.MM',
    });

    //Berekening prijs
    let cubicMetres;
    if($('.calculate-cubic-metres').length > 0) {
        CubicMetres.disableForm();

        let $length = $('[name="length"]');
        let $width = $('[name="width"]');
        let $height = $('[name="height"]');
        let previousAmountInCubicMetres;

        $('.calculate-cubic-metres input:not([name="cubic_metres"])').keyup(function(e) {

            CubicMetres.sanitizeField($(this));

            let length = parseFloat($length.val().replace(/[a-zA-Z]/, '').replace(/-/, ''));
            let width = parseFloat($width.val().replace(/[a-zA-Z]/, '').replace(/-/, ''));
            let height = parseFloat($height.val().replace(/[a-zA-Z]/, '').replace(/-/, ''));

            let cubicMetres = new CubicMetres(length, width, height);

            if(cubicMetres.isValid()) {
                previousAmountInCubicMetres = cubicMetres.amountInCubicMetres;
                $('[name="cubic_metres"]').val(cubicMetres.amountInCubicMetres);

                CubicMetres.enableForm();
            } else {
                CubicMetres.disableForm();
            }
        });

        $('.calculate-cubic-metres input[name="cubic_metres"]').keyup(function(e) {

            CubicMetres.sanitizeField($(this));

            if($(this).val() !== '' && parseFloat($(this).val()) !== parseFloat(previousAmountInCubicMetres)) {
                $length.val('');
                $width.val('');
                $height.val('');

                let cubicMetres = new CubicMetres(null, null, null, $(this).val());

                if(cubicMetres.isValid()) {
                    CubicMetres.enableForm();
                } else {
                    CubicMetres.disableForm();
                }
            }

            if($(this).val() === '') {
                CubicMetres.disableForm();
            }
        });
    }

    $('.order-option').change(function(e) {

        updateProgressBar();

        if(!$(this).hasClass('disable-request')) {
            calculatePrice();
        }
    });

    if(parseFloat($('[name="cubic_metres"]').val()) > 0) {
        CubicMetres.enableForm();
        $('.order-option').trigger('change');
    }

    $('.noEnterSubmit').keypress(function(e) {
        if(e.which == 13) return false;
    });

    /**
     * @description: Check addresses.
     */
    if($('#deliveryHouseNo').length > 0 && $('#deliveryZipcode').length > 0) {
        $('#deliveryHouseNo').change(function() {
            checkForAddress($('#deliveryZipcode'), $('#deliveryHouseNo'), $('#deliveryAdres'), $('#deliveryCity'));
        });

        $('#deliveryZipcode').change(function() {
            checkForAddress($('#deliveryZipcode'), $('#deliveryHouseNo'), $('#deliveryAdres'), $('#deliveryCity'));
        });
    }

    if($('#PersonalHouseNo').length > 0 && $('#PersonalPostcode').length > 0) {
        $('#PersonalHouseNo').change(function() {
            checkForAddress($('#PersonalPostcode'), $('#PersonalHouseNo'), $('#PersonalAdres'), $('#personalCity'));
        });

        $('#PersonalPostcode').change(function() {
            checkForAddress($('#PersonalPostcode'), $('#PersonalHouseNo'), $('#PersonalAdres'), $('#personalCity'));
        });
    }

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: (target.offset().top - 70)
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // Fade in background images
    setTimeout(function() {
        $('.background-image-holder').each(function() {
            $(this).addClass('fadeIn');
        });
    }, 200);

    // Tabbed Content
    $('.tabbed-content').each(function() {
        $(this).append('<ul class="content"></ul>');
    });

    $('.tabs li').each(function() {
        var originalTab = $(this),
            activeClass = "";
        if(originalTab.is('.tabs > li:first-child')) {
            activeClass = ' class="active-tab"';
        }
        var tabContent = originalTab.find('.tab-content').detach().wrap('<li' + activeClass + '></li>').parent();
        originalTab.closest('.tabbed-content').find('.content').append(tabContent);
    });

    $('.tabs li').click(function(e) {
        $(this).closest('.tabs').find('li').removeClass('active-tab');
        $(this).addClass('active-tab');
        var liIndex = $(this).index() + 1;
        $(this).closest('.tabbed-content').find('.content>li').removeClass('active-tab');
        $(this).closest('.tabbed-content').find('.content>li:nth-of-type(' + liIndex + ')').addClass('active-tab');

        $('html, body').animate({
            scrollTop: $(".order-form").offset().top + -120
        }, 500);
    });

    /**
     * @description: Makes sure the 'next' button goes to the next tab.
     */
    $('body').on('click', '.tab-next', function(e) {
        e.preventDefault();

        let target = parseInt($(this).data('target'));

        $('.progress-number').each(function() {
            if(parseInt($(this).text()) === target) {
                $(this).parents('li').click();
            }
        });
    });

    /**
     * @description: Makes sure if there's an error which isn't on the first tab, that it will open on the right tab.
     */
    if($('.alert.alert-danger').length > 0) {
        let target = parseInt($('.alert.alert-danger:visible').eq(0).closest('li').index()) + 1;

        $('.progress-number').each(function() {
            if(parseInt($(this).text()) === target) {
                $(this).parents('li').trigger('click');
            }
        });
    }

    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').click(function() {
        $('.navbar-collapse').collapse('hide');
    });

    // Activate scrollspy to add active class to navbar items on scroll
    $('body').scrollspy({
        target: '.usp-row',
        offset: 0
    });

    // Progress Bars
    var delay = 800;
    $(".progress-bar").each(function(i) {
        $(this).delay(delay * i).animate({width: $(this).attr('aria-valuenow') + '%'}, delay);

        $(this).prop('Counter', 0).animate({
            duration: delay,
            easing:   'swing',
            step:     function(now) {
                $(this).text(Math.ceil(now) + '%');
            }
        });
    });

    // Collapse Navbar
    var navbarCollapse = function() {
        if($("#scroll-indicator").offset().top > 40) {
            $("#mainNav").addClass("navbar-shrink");
        } else {
            $("#mainNav").removeClass("navbar-shrink");
        }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

    //margin for tabs
    var navbarCollapse = function() {
        if($("#scroll-indicator").offset().top > 40) {
            $("#sticky-tabs").addClass("tabs-visible");
        } else {
            $("#sticky-tabs").removeClass("tabs-visible");
        }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);


    //Ripple effect for buttons -> oh jazeker
    $.ripple(".btn", {
        debug: true, // Turn Ripple.js logging on/off
        on:    'mousedown', // The event to trigger a ripple effect

        opacity: 0.4, // The opacity of the ripple
        color:   "white", // Set the background color. If set to "auto", it will use the text color
        multi:   false, // Allow multiple ripples per element

        duration: 0.4, // The duration of the ripple

        // Filter function for modifying the speed of the ripple
        rate: function(pxPerSecond) {
            return pxPerSecond;
        },

        easing: 'linear' // The CSS3 easing function of the ripple
    });

    //Ripple effect for accordion
    $.ripple(".js-accordion-header", {
        debug: false, // Turn Ripple.js logging on/off
        on:    'mousedown', // The event to trigger a ripple effect

        opacity: 0.4, // The opacity of the ripple
        color:   "white", // Set the background color. If set to "auto", it will use the text color
        multi:   false, // Allow multiple ripples per element

        duration: 0.4, // The duration of the ripple

        // Filter function for modifying the speed of the ripple
        rate: function(pxPerSecond) {
            return pxPerSecond;
        },

        easing: 'linear' // The CSS3 easing function of the ripple
    });

})(jQuery); // End of use strict